var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerBiomassUnitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#000000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000, 25.000) scale(0.025000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424-262q13 11 27.5 15.5T480-242q29 0 52.5-18.5T560-314q5-47-29-69.5T480-442q-5 14-5 26t3 26q3 17 7 32t1 32q-5 18-22 37t-40 27ZM100-100v-760h760v760H100Zm380-120q50 0 85-35t35-85q0-24.77-10-40.77-10-16-28-29.23-38-27-63.5-56.5T458-526q-44 35-71 79.5T360-342q0 35 36 78.5t84 43.5Zm-320 60h93.85v-60h104.61Q332-245.92 316-278.88T300-342q0-43.69 10.39-81.5 10.38-37.81 34-72.15Q368-530 406.92-562.11q38.93-32.12 95.39-64.04-2.16 43.23 20.27 86.58 22.42 43.34 74.19 81.27 29.15 21.69 46.19 50.53Q660-378.92 660-340q0 33.85-12.35 64.31-12.34 30.46-36.11 55.69h94.61v60H800v-640H160v640Zm320-60Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerBiomassUnitIcon);
export default __webpack_public_path__ + "static/media/marker-biomassUnit-icon.a69d0a12d1a48a3665875a3f2bf3ffc8.svg";
export { ForwardRef as ReactComponent };